"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require("prop-types");

var _ToolbarSpacer = require("./ToolbarSpacer");

var _ToolbarSpacer2 = _interopRequireDefault(_ToolbarSpacer);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
/**
 * You can fix the toolbar to the top using the `fixed` prop. When doing this you can
 * ensure your content gets padded automatically using the `adjust` prop which will
 * insert a `<div>` behind the toolbar that is the correct height.
 *
 * ```js
 * <Toolbar fixed adjust>...</Toolbar>
 * ```
 *
 * Alternatively wrap your conntent in an element that has the `mdc-toolbar-fixed-adjust`
 * class.
 *
 * ```js
 * <div>
 *  <Toolbar fixed>
 *    <ToolbarRow>
 *      <ToolbarSection>
 *        <ToolbarTitle>Toolbar</ToolbarTitle>
 *      </ToolbarSection>
 *    </ToolbarRow>
 *  </Toolbar>
 *
 *  <div className="mdc-toolbar-fixed-adjust">
 *    Main content goes here
 *  </div>
 * </div>
 */


var Toolbar = function Toolbar(_ref) {
  var fixed = _ref.fixed,
      adjust = _ref.adjust,
      className = _ref.className,
      children = _ref.children,
      other = _objectWithoutProperties(_ref, ["fixed", "adjust", "className", "children"]);

  return _react2.default.createElement(_react.Fragment, null, _react2.default.createElement("header", _extends({
    className: (0, _classnames2.default)("mdc-toolbar", {
      "mdc-toolbar--fixed": fixed
    }, className)
  }, other), children), adjust && _react2.default.createElement(_ToolbarSpacer2.default, null));
};

Toolbar.propTypes = {
  /** Fix the toolbar to the top of the page. */
  fixed: _propTypes.bool,

  /** Auto-adjust content to take a fixed toolbar into account */
  adjust: _propTypes.bool
};
exports.default = Toolbar;